export const TASK_VIEW = { LIST: 'list', KANBAN: 'kanban' } as const
export const TASK_VIEW_STORAGE_KEY = 'tasks-view-mode'
export const TASK_COLUMN_PREFIX = 'task-column:'
export const TASK_CARD_PREFIX = 'task-card:'
export const TASK_DUE_FILTER = { OVERDUE: 'overdue' } as const
